import { render } from "./myShortCodes.vue?vue&type=template&id=1d14d095&scoped=true"
import script from "./myShortCodes.vue?vue&type=script&lang=js"
export * from "./myShortCodes.vue?vue&type=script&lang=js"

import "./myShortCodes.vue?vue&type=style&index=0&id=1d14d095&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d14d095"]])

export default __exports__